import React from 'react';
import { useSelector } from 'react-redux';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { TcsmStates } from '../../../../root/tcsm-model';
import { MyCPGMidYearProps } from './models/mycpg-midyear-epi-props';
import { useQuery } from '../../../../global/hooks/useQuery';
import { useNewHireSettings } from '../../../arc/features/new-hire/hooks/useNewHireSettings';
import { MyCPGMidYearConfirmationView } from './mycpg-midyear-confirmation-view';
import { Breadcrumbs } from '../../../../global/components/breadcrumbs';
import { TcsmSiteSettingsProps } from '../../../../global/models/epi-model';



interface Props {
    settignsId: string
}

const defaultStatus = 'default';


export function MyCPGMidYearConfirmation(props: Props) {

    const { settignsId } = props;
    const settingLoaded = useNewHireSettings(settignsId);
    const myCpgMidyearSettings = useSelector<TcsmStates, MyCPGMidYearProps>(state => state?.epiProps?.myCpgMidyearSettingsState?.epiContent);
    const query = useQuery()?.get('status') || defaultStatus;
    const siteSettings = useSelector<TcsmStates, TcsmSiteSettingsProps>(state => state?.epiProps?.siteSettingsState?.siteSettings);
    if (!settingLoaded) {
        return <LoadingCircle />;
    }

    const model = myCpgMidyearSettings?.myCPGMidyearConfirmationSettings?.find(m => m?.statusCode === query);

    return (
        <>
            <Breadcrumbs routeBreadcrumbs={siteSettings?.routeBreadcrumbs} />
            <MyCPGMidYearConfirmationView model={model} />
        </>
    );

}
